import { css } from '@emotion/react';
import { Gray, White } from '@constants/color';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  color: White.White10
});

export const content = css({
  height: 1080,
  width: 1280,
  display: 'flex',
  justifyContent: 'center'
});

export const buttonContainer = css({
  height: '952px',
  width: '512px',
  backgroundColor: Gray.Gray90,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  rowGap: '3vh',
  padding: '64px'
});

export const title = css({
  color: White.White10,
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '130%',
  alignSelf: 'center',
  whiteSpace: 'pre-wrap'
});
